import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "es",
    fallbackLng: 'es',
    resources: {
      es: {
        translation: {
          info: {
            aboutme: "{{ text }}"
          },
          form: {
            title: "Contacto",
            input_name: "Tu nombre*",
            input_email: "Tu email*",
            message: "Envia tu mensaje*",
            button: "Enviar",
            buttonSending: "Enviando...",
            message_sent: "Mensaje enviado!",
            message_sent_error: "Error al enviar el mensaje, intente nuevamente!",
            error_name_required: "El nombre es requerido",
            error_email_required: "El email es requerido",
            error_email_invalid: "El formato de mail no es valido",
            error_message_required: "El mensaje es requerido"
          },
          back_to_top: {
            title: "Volver arriba"
          },
          sidenav: {
            projects: "proyectos",
            aboutme: "sobre mi",
            contact: "contacto",
            instagram: "Sigueme!"
          }
        },
      },
      en: {
        translation: {
          info: {
            aboutme: "{{ text }}"
          },
          form: {
            title: "Contact",
            input_name: "Your name*",
            input_email: "Your email*",
            message: "Send your message*",
            button: "Submit",
            buttonSending: "Sending...",
            message_sent: "Message sent!",
            message_sent_error: "Error sending message, try again!",
            error_name_required: "The name is required",
            error_email_required: "The email is required",
            error_email_invalid: "The email format is not valid",
            error_message_required: "The message is required"
          },
          back_to_top: {
            title: "back to top"
          },
          sidenav: {
            projects: "projects",
            aboutme: "about me",
            contact: "contact",
            instagram: "Follow me!"
          }
        },
      },
    },
  });
